import { render, staticRenderFns } from "./mobilePage.vue?vue&type=template&id=d9f43c20&scoped=true"
import script from "./mobilePage.vue?vue&type=script&lang=js"
export * from "./mobilePage.vue?vue&type=script&lang=js"
import style0 from "./mobilePage.vue?vue&type=style&index=0&id=d9f43c20&prod&lang=scss&scoped=true"
import style1 from "./mobilePage.vue?vue&type=style&index=1&id=d9f43c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f43c20",
  null
  
)

export default component.exports